import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function NotificationBanner({ notif, show, onClose, theme }) {
  if (!theme) {
    theme = {
      colors: {
        background: "#fff",
        text: "#222",
        logoBackground: "#eee",
        logoText: "#222",
      },
      fontFamily: "inherit",
    };
  }

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -80, opacity: 0 }}
          transition={{ type: "spring", stiffness: 400, damping: 32 }}
          className="fixed top-0 left-0 w-full z-50 flex justify-center"
        >
          <div
            className="relative mt-16 px-6 py-3 rounded-xl shadow text-base font-semibold flex items-center justify-center"
            style={{
              background: theme.colors.background,
              color: theme.colors.text,
              fontFamily: theme.fontFamily,
              border: `1.5px solid ${theme.colors.text}`,
              minWidth: 320,
            }}
          >
            <div className="w-full text-center">{notif}</div>
            <button
              className="absolute right-4 top-1/2 -translate-y-1/2 text-lg font-bold hover:opacity-70"
              style={{
                color: theme.colors.text,
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
              onClick={onClose}
              aria-label="Close notification"
            >
              ×
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
